//React base styles
import typography from "assets/mavric-theme/base/typography";

// React helper functions
import pxToRem from "assets/mavric-theme/functions/pxToRem";

const { size } = typography;

const dialogTitle = {
  styleOverrides: {
    root: {
      padding: pxToRem(16),
      fontSize: size.xl,
    },
  },
};

export default dialogTitle;
